
import Datetime from 'vux/src/components/datetime/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Countup from 'vux/src/components/countup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'


export default {
components: {
Datetime,
PopupPicker,
Countup,
Popup,Group,PopupHeader,XButton,Radio
},
directives: {
TransferDom
},
data() {
return {
showDates:false,
pickerStatus:false,
dateStatus:false,
detailPop:false,
index:0,
startDate:'',
endDate:'',
info:{},
list:[],
grade:0,
}
},
created(){
this.grade = parseInt(this.$func.getLocal('grade'));
this.setDate();
setTimeout(() => {
this.getData();
}, 300);
},
methods: {
setDate() {
this.startDate = this.$func.getCurrentDate();
this.endDate = this.$func.getCurrentDate();
},
showDate(e){
this.index = e;
this.dateStatus = true;
},
previous(){
this.startDate = this.$func.modifyDate(this.startDate,-1);
this.endDate = this.startDate;
this.getData();
},
next(){
this.startDate = this.$func.modifyDate(this.startDate,1);
this.endDate = this.startDate;
this.getData();
},
dateChange(e){
if(this.index > 0){
this.endDate = e;
}else{
this.startDate = e;
}



},
reset(){
this.setDate();
setTimeout(() => {
this.getData();
}, 300);
},
getData() {
if(!this.startDate || !this.endDate){
this.$func.showToast('请选择日期');
return;
}
this.$func.startLoading();
this.$api.contractFactoryRewardData({status:this.type,start:this.startDate,end:this.endDate}).then((res)=>{
if(res){
this.info = res.data;
this.pickerStatus = false;
this.detailPop = false;
this.$func.endLoading();
}
})
},
getDetail() {
if(!this.startDate || !this.endDate){
this.$func.showToast('请选择日期');
return;
}
if(this.detailPop){
this.detailPop = false;
return;
}
this.$func.startLoading();
this.$api.contractFactoryRewardDataDetail({start:this.startDate,end:this.endDate}).then((res)=>{
if(res){
this.list = res.data;
this.detailPop = true;
this.$func.endLoading();
}
})
},

}
}



// WEBPACK FOOTER //
// ./src/pages/factoryProfitData.vue